module.exports = __webpack_public_path__ + "static/media/Back-Lower-Limb(L) v2.f2d0be13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Back-Lower-Limb(L) v2.png
// module id = 415
// module chunks = 0